<template>
    <!-- <b-modal size="lg" id="modalRegistrarAfericao" v-model="registraAfericao" data-backdrop="static"
        data-keyboard="false" centered :title="'NR Fogo: ' + pneu"> -->
    <div id="registraAfericao">

        <div class="col-6 container mb-4">
            <span class="">{{ $t('Informar KM') }}:</span>
            <input type="number" class="form-control" v-model="km_informado">
        </div>

        <div class="container mb-3">
            <div class="col-12 d-flex justify-content-center">
                <p>{{ $t('Última aferição NR fogo') }}:
                    <span class="badge badge-warning" style="font-size:16px">{{
                pneu.nr_fogo
            }}</span>
                </p>

            </div>
            <div class="col-12 d-flex justify-content-center">
                <span class="col-5">{{ $t('Registrar Aferições') }}:</span>
            </div>

            <div class="col-12 d-flex justify-content-center" v-for="(mm, index) in afericoesFeitas" :key="index">
                <input class="col-5 form-control m-1" type="number" :value="mm.valor"
                    @change="inputAfericao(mm, $event)">
            </div>
        </div>

        <!-- <template #modal-footer> -->
        <div class="w-100">
            <div class="row center mb-3" style="justify-content: center;">
                <!-- <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                    {{ $t('Cancelar') }}
                </b-button> -->
                <b-button size="lg" variant="success" @click="registrarRemovePneu">
                    {{ $t('Confirmar') }}
                </b-button>
            </div>
        </div>
    </div>
    <!-- </template> -->
    <!-- </b-modal> -->
</template>
<script>

export default {
    name: "ModalExterna",
    props: {
        afericoesFeitas: {},
        pneu: {},
        veiculo: {}
    },

    data() {
        return {
            arrayAfericoes: [],
            registraAfericao: true,
            afericoesFeitasTemp: [],
            km_informado: ''
        };
    },
    methods: {

        insereValorKm() {
            console.log(this.veiculo)
            // this.km_informado = this.veiculo.km_atual
        },
 
        registrarRemovePneu() {
            console.log(this.pneu)

            let ds_lado = this.pneu.ds_lado
            let nr_posicao = this.pneu.nr_posicao
            let nr_vida = this.pneu.nr_vida

            const dataAfericao = {
                nr_fogo: this.pneu.nr_fogo,
                veiculo: this.veiculo,
                ds_lado: ds_lado,
                nr_posicao: nr_posicao,
                afericoes: this.arrayAfericoes,
                nr_vida: nr_vida,
                km_informado: this.km_informado,
                idpneu: this.pneu.idpneu
            }
            console.log(dataAfericao)

            this.$store.dispatch('borracharia/removerPneu', { data: dataAfericao }).then(() => {
                this.$emit('refreshCaminhao')
                this.$store.dispatch('borracharia/getPneusBD')
            })

            // .then(response => {
            //     this.$swal.fire({
            //         title: "Removido!",
            //         text: "Pneu removido com sucesso.",
            //         icon: "success"
            //     });
            // }).catch(() => {
            //     this.$swal.fire({
            //         title: "Oops!",
            //         text: "Erro ao remover o pneu.",
            //         icon: "error"
            //     });
            // })
        },

        inputAfericao(mm, event) {
            if (Number(event.target.value) > Number(mm.valor)) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Informe uma aferição menor que a atual!',
                    icon: 'warning'
                })

                event.target.value = ''
                return false
            }

            let data = {
                index: mm.indice,
                ultimaAfericao: mm.valor,
                novaAfericao: event.target.value
            }

            var indice = this.arrayAfericoes.findIndex(function (item) {
                return item.index === data.index;
            });

            if (indice !== -1) {
                this.arrayAfericoes[indice] = data;
            } else {
                this.arrayAfericoes.push(data);
            }
        },

        populaArrayAfericao() {
            this.km_informado = this.veiculo.km_atual
            this.afericoesFeitas.forEach(element => {
                let data = {
                    index: element.indice,
                    ultimaAfericao: element.valor,
                    novaAfericao: element.valor
                }

                this.arrayAfericoes.push(data)
            })

            console.log(this.arrayAfericoes)
        }

    },
    created() {
        
        this.populaArrayAfericao()
        console.log('Iniciou o Modal')

    }
}
</script>
